import DiscountCoupon from '@activities/order/OrderActivity/components/Discount/DiscountCoupon';
import Accordion from '@components/Accordion';
import Button from '@components/Button';
import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import useModal from '@hooks/ui/useModal';
import useCalculatedRequest from '@store/order/hooks/useCalculatedRequest';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import useDiscounts from './hooks/useDiscounts';

function Discount() {
    const discounts = useDiscounts();
    const { orderLines } = useCalculatedRequest();

    const { t } = useTranslation('order');
    const enabledCouponCount = useMemo(() => {
        if (discounts.coupons) {
            const selectedItemIds = orderLines.map((item) => item.shopItemId);
            const filtered = discounts.coupons.filter((coupon) => {
                const { applicableItemIds } = coupon;
                if (applicableItemIds && applicableItemIds.length !== 0) {
                    return selectedItemIds.filter((itemId) => applicableItemIds?.includes(itemId))?.length !== 0;
                }
                return selectedItemIds.length !== 0;
            });
            return filtered.length;
        }
        return 0;
    }, [discounts, orderLines]);
    return (
        <Accordion title={
            <Row spacing={6}>
                <Text size='lg' fontWeight='bold'>{t('discount.title')}</Text>
                <InfoText>
                    {t('discount.availableCoupons')} <em>{enabledCouponCount.toLocaleString()}{t('discount.couponUnit')}</em>
                </InfoText>
                {/*
                <InfoText>
                    선물 <em>{discounts?.gifts.length.toLocaleString() || 0}개</em>
                </InfoText> */}
            </Row>
        }>
            <Container spacing={18}
                fullWidth>
                <Column fullWidth spacing={8}>
                    {(discounts.coupons?.length || 0) > 0 && (
                        <Row align='center'>
                            <Text
                                fontWeight='bold'
                                color={colors.gray7}>
                                {t('discount.couponApply')}
                            </Text>
                            {/* <Info/> */}
                        </Row>
                    )}
                    <Column fullWidth spacing={12}>
                        {discounts?.coupons?.map(((c) => (
                            <DiscountCoupon coupon={c}
                                key={c.id} />
                        )))}
                    </Column>
                </Column>
                {/*
                <Column fullWidth spacing={8}>
                    <Row align='center'>
                        <Text
                              fontWeight='bold'
                              color={colors.gray7}>
                            선물 적용
                        </Text>
                        <Info/>
                    </Row>
                    <Column spacing={12} fullWidth>
                        <DiscountItem isChecked={gifts.includes('1')}
                                      onClick={() => toggleGift('1')}
                                      discountAmount={2000}
                                      expiresAt={new Date()}>
                            친구가 준 아메리카노 쿠폰
                        </DiscountItem>
                    </Column>
                </Column>
                */}
            </Container>
        </Accordion>
    );
}

const InfoText = styled(Text)`
    em {
        font-style: normal;
    }
`;

const Container = styled(Column)`
    padding: 12px  0 28px;
`;

export default Discount;
